import { combineReducers } from "redux";
import headerRed from "./headerRed";

export default combineReducers({
  headerdata: headerRed  
  //   user: user,
  //   commonReducers:commonReducers
}); 
